
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"16","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.708 5.695a1 1 0 01-1.413 0L5.006 2.41 1.717 5.695a1 1 0 11-1.412-1.41L4.3.291a1 1 0 011.412 0l3.996 3.992a.998.998 0 010 1.411zM.292 10.305a1 1 0 011.413 0l3.289 3.286 3.289-3.286a1 1 0 111.412 1.41L5.7 15.709a1 1 0 01-1.412 0L.292 11.716a.997.997 0 010-1.411z"}})])
          )
        }
      }
    